<template>
  <div class="verify-email-container">
    <img src="../../../../public/build/icons/mail-envelope.svg" height="48" width="48" alt="Envelope">
    <h1>{{ __('Verifique seu e-mail') }}</h1>
    <h2>
      {{ __('Enviamos um e-mail para') }}<br/>
      <span>{{ userEmail }}.</span> <br/>
      {{ __('Verifique seu e-mail para') }} <br/>
      {{ __('continuar o cadastro.') }}
    </h2>
    <a href="/cadastro">
      {{ __('Voltar') }}
    </a>
    <div v-if="!isMessageSent" style="display: flex; align-items: center; gap: 2;">
      <p>{{ __('Não recebeu a mensagem?') }}</p>
      <span class="resend" @click="resendEmail">{{ __('Reenviar') }}</span>
    </div>
    <p v-else class="timer-text">
      <span>{{ __('Mensagem reenviada. Aguarde') }}</span>
      <span class="timer">{{ formatTime(timeToResendMessage) }}</span>
      {{ __('para reenviar novamente') }}
    </p>
    <img src="../../../../public/build/images/salesflow-logo-gray.svg" alt="Salesflow">
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { Alert } from '../../services/alert.js';

export default {
  data() {
    return {
      userEmail: "",
      isMessageSent: false,
      timeToResendMessage: 60,
      timerId: null,
      isSendingMessage: false
    }
  },

  created() {
    this.userEmail = localStorage.getItem('verify-email');
    this.initializeTimer();
  },

  methods: {
    resendEmail() {
      if(this.isSendingMessage) return;
      this.isSendingMessage = true;
      this.$http.post('auth/verify-token-notification', { email: this.userEmail })
        .then(response => {
          this.isMessageSent = true;
          let futureTime = dayjs().add(60, 'second');
          sessionStorage.setItem('resendTime', futureTime.valueOf());
          this.startTimer();
        })
        .catch(error => {
          if(error.data.email) {
            return Alert.error('Nenhum e-mail fornecido. Realize o cadastro novamente.')
          }
          if(error.status === 429) {
            return Alert.error('Aguarde 1 minuto para reenviar novamente.')
          }
          return Alert.error('Algum erro ocorreu. Tente novamente mais tarde.')
        })
        .finally(() => this.isSendingMessage = false);
    },

    startTimer() {
      if (this.timerId !== null) {
        clearTimeout(this.timerId);
      }

      this.timerId = setTimeout(() => {
        let currentTime = dayjs();
        let futureTime = dayjs(parseInt(sessionStorage.getItem('resendTime')));
        let timeLeft = futureTime.diff(currentTime, 'second');

        if (timeLeft > 0) {
          this.timeToResendMessage = timeLeft;
          this.startTimer();
        } else {
          this.timeToResendMessage = 60;
          this.isMessageSent = false;
          sessionStorage.removeItem('resendTime');
        }
      }, 1000 - new Date().getMilliseconds());
    },

    // caso a página seja recarregada:
    initializeTimer() {
      let resendTime = sessionStorage.getItem('resendTime');
      if (resendTime) {
        let currentTime = dayjs();
        let futureTime = dayjs(parseInt(resendTime));
        let timeLeft = futureTime.diff(currentTime, 'second');
        if (timeLeft > 0) {
          this.timeToResendMessage = timeLeft;
          this.isMessageSent = true;
          this.startTimer();
        } else {
          sessionStorage.removeItem('resendTime');
          this.isMessageSent = false;
        }
      }
    },

    formatTime(seconds) {
      let minutes = Math.floor(seconds / 60);
      let remainingSeconds = seconds % 60;
      return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
    },
  }
}
</script>

<style lang="scss" scoped>
@import '../../../sass/variables';
@import '../../../sass/mixins';

.verify-email-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  width: 608px;
  padding: 40px 80px;
  border-radius: 40px;
  background: #FBFBFB;
  box-shadow: 0px 8px 24px 0px rgba(0, 0, 0, 0.10);
  font-family: 'Inter';
  color: $salesflow-font-gray;

  h1 {
    font-size: 24px;
    font-weight: 700;
    line-height: 150%;
    margin-bottom: 0;
  }

  h2 {
    font-size: 16px;
    font-weight: 500;
    text-align: center;
    line-height: 150%;
    margin-bottom: 0;

    span {
      font-weight: 600;
    }
  }

  a {
    display: flex;
    padding: 12px 32px;
    justify-content: center;
    align-items: center;
    border-radius: 14px;
    border: 1px solid $salesflow-outline-gray-light;
    background: $salesflow-outline-gray-light;
    font-family: 'Montserrat';
    font-weight: 600;
    font-size: 16px;
    color: $salesflow-font-dark;
    line-height: 150%;
    cursor: pointer;
  }

  a:hover {
    color: $salesflow-font-dark;
    background-color: $salesflow-outline-gray-medium;
    text-decoration: none;
  }

  p {
    font-size: 14px;
    line-height: 150%;
    margin-bottom: 0;

    .timer {
      font-weight: 700;
      display: inline-block;
      min-width: 47px !important;
    }
  }

  .resend {
    color: $salesflow-primary;
    font-size: 12px;
    font-weight: 600;
    line-height: 150%;
    text-decoration-line: underline;
    cursor: pointer;
    margin-left: 8px;
    margin-top: 3px;
  }

  .resend:hover {
    color: $salesflow-primary-hover;
  }

  .timer-text {
    text-align: center;
  }
}


// mobile
@media screen and (max-width: 743px) {
  .verify-email-container {
    width: 380px;
    padding: 40px 40px;
  }

  a {
    width: 100%;
  }
}

@media screen and (max-width: 343px) {
  h1 {
    font-size: 20px !important;
  }

  p {
    font-size: 12px !important;
  }
}

@media screen and (max-width: 375px) {
  .verify-email-container {
    padding: 40px 28px !important;
  }
}

@media screen and (min-width: 380px) {
  p {
    font-size: 15px !important;
  }
}

@media screen and (min-width: 400px) {
  p {
    font-size: 16px !important;
  }
}
</style>
